import React from 'react';
import PropTypes from 'prop-types';
import {Menu, Dropdown, Row} from 'antd';
import {DownOutlined} from '@ant-design/icons';

const UserActions = ({showBranch, name, branchName, logout, changeBranch}) => {

    const menu = (
        <Menu className='header-dropdown-menu'>
            {showBranch && (
              <Menu.Item key="0" style={{padding: 14}}>
                <div className='header-dropdown-item' onClick={changeBranch}>Փոխել մասնաճյուղը</div>
              </Menu.Item>
            )}
            <Menu.Item key="1" style={{padding: 14}}>
                <div className='header-dropdown-item' onClick={logout}>Ելք համակարգից</div>
            </Menu.Item>
        </Menu>
    );

    return (
        <Dropdown overlay={menu} trigger={['click']}>
            <div className="header-dropdown">
                <Row type='flex' style={{ display: 'flex', justifyContent: 'space-between', padding: '0 16px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div className='header-name'>{name}</div>
                        <div className='header-branch-name'>{branchName}</div>
                    </div>
                    <div className='header-dropdown-down'>
                        <DownOutlined style={{ width: '24px', height: '24px' }} />
                    </div>
                </Row>
            </div>
        </Dropdown>
    )
};

UserActions.propTypes = {
    name: PropTypes.string.isRequired,
    branchName: PropTypes.string.isRequired,
    logout: PropTypes.func.isRequired,
    changeBranch: PropTypes.func.isRequired,
};

export default UserActions;

